import React from "react";
import { Route, Routes } from "react-router-dom";
// import { OrderDetails } from "./details/";
import { ProductsList } from "./list";
import { ProductInfo } from "./details";

const ProductsModule = () => {
  return (
    <Routes>
      <Route index element={<ProductsList />} />
      <Route path="details/:productId" element={<ProductInfo />} />
    </Routes>
  );
};

export default ProductsModule;
